// This file is autogenerated. Any changes will be overwritten.

export const set = 'budicon';

export const name = 'arrow-left-right';

export const Component = () => (
  <path d='M13.734 13.812s1.006.335 1.006.958c0 .67-.335 1.005-1.006 1.005H2.96c-.623 0-.958-.335-.958-1.005 0-.623.335-.958.958-.958h10.775Zm8.86-5.89s.958.334.958 1.005c0 .622-.335.957-.957.957H11.819c-.67 0-1.006-.335-1.006-.957 0-.67.335-1.006 1.006-1.006h10.776ZM8.563 19.031s.526.91 0 1.34c-.432.432-.862.432-1.39 0l-4.884-4.884a.976.976 0 0 1-.288-.72c0-.238.096-.478.288-.67l4.885-4.885c.479-.526.957-.526 1.389 0 .526.432.526.91 0 1.34L4.347 14.77l4.215 4.262v.001Zm14.703-9.435-4.885 4.885c-.48.527-.958.527-1.39 0-.526-.431-.526-.91 0-1.34l4.215-4.215-4.214-4.263c-.527-.431-.527-.91 0-1.34.43-.432.861-.432 1.389 0l4.885 4.885a.976.976 0 0 1 .287.718v.48h-.479l.192.19Z' />
);

export const viewBox = '0 0 25 25';
